module.exports = __webpack_public_path__ + "img/logo-mo-32.02bad8ff.svg";